import { render, staticRenderFns } from "./TimetableSplitViewEventListItem.vue?vue&type=template&id=0848554b"
import script from "./TimetableSplitViewEventListItem.vue?vue&type=script&lang=js"
export * from "./TimetableSplitViewEventListItem.vue?vue&type=script&lang=js"
import style0 from "./TimetableSplitViewEventListItem.vue?vue&type=style&index=0&id=0848554b&prod&lang=postcss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports